import React from 'react';
import $ from 'jquery';
import {Redirect} from "react-router-dom";
import {TextInput, PQDLogo, Button, AlertBox } from '../components/components.js';

class PassReset extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      submitting: false,
      failed : false,
      code: '',
      resetData : {},
      newpassword : '',
      confpassword : '',
      alert : ''
    };

    this.handleInputUpdate = this.handleInputUpdate.bind(this);
    this.resetClick = this.resetClick.bind(this);

  }

  resetClick() {
    if(!this.state.newpassword || !this.state.confpassword) {
      this.setState({alert : 'All fields must be filled in'});
      return;
    } 
    if(this.state.confpassword !== this.state.newpassword) {
      this.setState({alert : 'Passwords don\'t match'});
      return;
    }
    if(this.state.newpassword.length < 8) {
      this.setState({alert : 'Passwords must be at least 8 characters long'});
      return;
    }
    if(!this.state.newpassword.match(/(?=.*\d)(?=.*[a-z])(?=.*[A-Z])/)) {
      this.setState({alert : 'Passwords must contain at least one upper case, one lower case, and one number'});
      return;
    }

    this.setState({
      submitting : true
    });

    var comp = this;
    
    window._fiUser.UPDATE((response) => {
      comp.setState({ failed : (response.code !== 200), code : response.code, resetData : response});
    }, this.state.newpassword)
  }

  handleInputUpdate(value, dataId) {
    var stateObj = {};
    stateObj[dataId] = value;
    this.setState(stateObj)
  }

  componentDidMount() {

    window._fiUser.loadSessionInfo();

    $('[dataid="confpassword"]').off().keypress(function(e) { //If hit enter on password, click login.
      if(e.originalEvent.which === 13) {
        $('[dataid="submit"]').click();
      }
    });

    $('[dataid="newpassword"]').off().keypress(function(e) {
      if(e.originalEvent.which === 13) {
        $('[dataid="confpassword"]').focus();
      }
    });

    //console.log('mounted = true');
    window.app.page_finished = true;
  }

  render() {
    //console.log('render = false');
    window.app.page_finished = false;

    const logoSize = {
      width : '40vmin',
      height : 'auto'
    };

    var alertType = (this.state.failed || this.state.alert.length) ? 'Error' : (this.state.code === 200) ? 'Success' : '';
    var alertContent = (this.state.failed) ? this.state.failed : (this.state.code === 200) ? 'Reset Successful!' : '';

    if(this.state.alert) {
      alertContent = this.state.alert;
    }

    var submittingAddon = (this.state.submitting) ? ( <div className="App-LoadLayer"><div className="App-Loader login"></div></div> ) : '';
    const render = ( //If we haven't yet logged in, we're going to render the page
      <div className="Login">
        <div className="Login-Body">
          {submittingAddon}
          <PQDLogo class="Login-Logo" size={logoSize} />
          <div className="Login-Label">Reset Password</div>
          <div className="Login-Content">
            <div className="Login-Constrictor">
              <AlertBox type={alertType} content={alertContent} />
              <TextInput class="App-TextInput" dataId="newpassword" handleChange={this.handleInputUpdate} placeholder="new password" value={this.state.newpassword} type="password" />
              <TextInput class="App-TextInput" dataId="confpassword" handleChange={this.handleInputUpdate} placeholder="confirm password" value={this.state.confpassword} type="password" />
              <Button class="App-Button" dataId="submit" label="Update" onClick={this.resetClick} />
            </div>
          </div>
        </div>
      </div>
    );


    if(this.state.submitting && Object.entries(this.state.resetData).length > 0 && this.state.failed === false) {
      const redirect = (<Redirect to='/Home' />); //Otherwise we will render the redirect to Home.
      return redirect;
    }

    return render; 
  }
}


export default PassReset;



